import React, { useEffect, useState } from 'react';
import { useFormContext } from '../context/FormContext';
import { useHistory } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import Session from './auth/Session';

const Home = () => {
    const [selected, setSelected] = useState(null);
    const history = useHistory();

    const { resetForm } = useFormContext();

    useEffect(() => {
        async function checkPolicyRedirect() {
            const token = Session.getToken();
            if (!token) return;

            const roles = Session.getRole() || '';
            if (roles.includes('Admin') || roles.includes('CSR')) {
                history.push('/data/dashboard');
                return;
            };

            const email = Session.getUserName();
            if (!email) return;

            try {
                const response = await fetch(
                    `api/Quote/HasActivePolicy?email=${encodeURIComponent(email)}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const result = await response.json();
                if (result.hasActivePolicy) {
                    history.push('/dashboard');
                    return;
                }
            } catch (err) {
                console.error('Policy check failed:', err);
            }

            // SECONDARY CHECK: if no active policy, check for a recently-issued 'Referred' quote
            try {
                const resp = await fetch(
                    `api/Quote/GetDashboardDataByEmail?email=${encodeURIComponent(email)}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (resp.ok) {
                    const result2 = await resp.json();
                    const quote = result2?.data?.quote;
                    const status = (quote?.status || quote?.Status || '').toString().trim().toLowerCase();

                    if (status === 'referred') {
                        // Determine an effective date to base the 1-year window on.
                        const effStr = quote?.policyEffectiveDate || quote?.effectiveDate;
                        if (effStr) {
                            const effDate = new Date(effStr);
                            if (!isNaN(effDate.getTime())) {
                                const oneYear = new Date(effDate);
                                oneYear.setFullYear(oneYear.getFullYear() + 1);
                                const today = new Date();
                                // Redirect if today is before (less than) effectiveDate + 1 year
                                if (today < oneYear) {
                                    history.push('/dashboard');
                                    return;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                console.error('Referred quote check failed:', err);
            }
        }

        checkPolicyRedirect();
    }, []);

    const handleContinue = () => {
        if (selected === 'quote'){
            // wipe session. Start fresh
            resetForm();
            history.push('/signup/eligibility');
        }
        if (selected === 'existing') history.push('/find-quote');
    };

    const options = [
        {
            id: 'quote',
            title: 'Request a quote',
            description: 'Get coverage for your property',
        },
        {
            id: 'existing',
            title: 'Continue existing quote',
            description: 'Resume your saved application',
        },
    ];

    return (
        <div className="page-centered" style={{ flexDirection: 'column', gap: 'var(--space-xl)' }}>
            <div className="" style={{ width: '100%', maxWidth: '580px' }}>

                {/* Heading */}
                <div style={{ marginBottom: 'var(--space-lg)' }}>
                    <h3 className="text-h1" style={{fontSize: 'var(--fs-h1)'}}>Start your quote</h3>
                    <p className="text-default" style={{ margin: 0 }}>
                        Elevana Solutions helps you secure parametric hurricane insurance for when a storm impacts your area.
                    </p>
                </div>

                {/* Option cards */}
                {options.map((option) => {
                    const isSelected = selected === option.id;
                    return (
                        <div
                            key={option.id}
                            className="card"
                            onClick={() => setSelected(option.id)}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 'var(--space-md)',
                                marginBottom: 'var(--space-lg)',
                                cursor: 'pointer',
                                borderColor: isSelected ? 'var(--border-selected)' : 'var(--border-subtle-color)',
                                background: isSelected ? '#ECF4F3' : 'var(--color-white)',
                                transition: 'all var(--duration-200) var(--ease-standard)',
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={isSelected}
                                onChange={() => setSelected(option.id)}
                                style={{ accentColor: 'var(--brand-primary)', width: 18, height: 18, flexShrink: 0 }}
                            />
                            <div>
                                <p className="text-h4--primary" style={{ margin: 0 }}>
                                    {option.title}
                                </p>
                                <p className="text-small" style={{ margin: 0 }}>
                                    {option.description}
                                </p>
                            </div>
                        </div>
                    );
                })}

                {/* Continue button */}
                <div style={{ marginTop: 'var(--space-lg)' }}>
                    <button
                        className="btn"
                        disabled={!selected}
                        onClick={handleContinue}
                        style={{ width: '100%' }}
                    >
                        Continue <MdArrowForward size={16} />
                    </button>
                </div>

                {/* Footer links */}
                <div style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
                    <p className="text-small" style={{ margin: '0 0 var(--space-xs)' }}>
                        Already have an account?
                        <br />
                        <a href="/login" className="auth-link">Access your member portal</a>
                    </p>
                    <p className="text-small" style={{ margin: 0, marginTop: 'var(--space-md)' }}>
                        Questions? Call us at <a href="tel:8772695422">877-269-5422</a> to connect.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default Home;